import styles from "./BackButton.module.scss";

export function BackButton(props: { click: () => void }) {
    return <div onClick={props.click} className={styles.button}><span className="material-icons">keyboard_backspace</span>
        <span className={styles.backButton}>BACK</span></div>
}